
import { IUserProfile } from "../types/User/IUserProfile";

export const INITIAL_USER_CONTEXT: Partial<IUserProfile> = {};
export class Constants {
  //Identity server settings
  public static stsAuthority = "https://login.revelationhelpdesk.com/common/";
  // public static stsAuthority = "https://localhost:5001/common/";
  public static clientId = "Revelation.NewUX";
  //public static clientRoot = "https://localhost:4200/";
  public static clientRoot = window.location.origin + process.env.PUBLIC_URL; // window.location.pathname;
  public static clientScope = "offline_access Revelation.Api"; //openid makes sure we get the id_token so we get the "Sign back in" button on the logout page.

  //Revelation API (V2) (moved to .env)
  public static apiRoot = process.env.REACT_APP_REVELATION_API_URL;
  public static appInsightsInstrumentationKey = process.env.REACT_APP_APPLICATION_INSIGHTS_CONNECTION;
}
//console.log('process.env.REACT_APP_REVELATION_API_URL', process.env)

const REVELATION_IFRAME = "RevelationIframe";

const ticketFilters = [
  "Check All",
  "Quick Search",
  "Tickets Open",
  "Tickets Closed",
  "Client",
  "Projects",
  "People",
  "KBs",
  "Assets",
];
const profileDropdownItems = [
  "My Account",
  "Ticket Monitor",
  "Email Signature",
  "@Tag Settings",
  "Single Sign On",
  "Interface Options",
  "Product Tour",
];
const symbolSize = 30;
export {
  REVELATION_IFRAME,
  ticketFilters,
  profileDropdownItems,
  symbolSize
};
